import { __assign } from 'tslib';
import { Location, CommonModule } from '@angular/common';
import { BehaviorSubject, Subject } from 'rxjs';
import { ignoreElements } from 'rxjs/operators';
import { Injectable, Optional, SkipSelf, InjectionToken, NgModule, defineInjectable, Inject, inject } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StorageService = /** @class */ (function () {
    function StorageService() {
        this.window = window;
        this.localStorage = window.localStorage;
        this.sessionStorage = window.sessionStorage;
    }
    /*
     Write methods
     */
    /*
       Write methods
       */
    /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    StorageService.prototype.setLocalObject = /*
       Write methods
       */
    /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    function (key, obj) {
        return this.setObject(this.localStorage, key, obj);
    };
    /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    StorageService.prototype.setLocalItem = /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    function (key, obj) {
        this.setItem(this.localStorage, key, obj);
    };
    /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    StorageService.prototype.setSessionObject = /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    function (key, obj) {
        return this.setObject(this.sessionStorage, key, obj);
    };
    /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    StorageService.prototype.setSessionItem = /**
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    function (key, obj) {
        this.setItem(this.sessionStorage, key, obj);
    };
    /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    StorageService.prototype.setObject = /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    function (storage, key, obj) {
        /** @type {?} */
        var jsonString;
        try {
            jsonString = JSON.stringify(obj);
        }
        catch (ex) {
            return false;
        }
        this.setItem(storage, key, jsonString);
        return true;
    };
    /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    StorageService.prototype.setItem = /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @param {?} obj
     * @return {?}
     */
    function (storage, key, obj) {
        storage.setItem(key, obj);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    StorageService.prototype.setWindowName = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.window.name = value;
    };
    /*
     Read methods
     */
    /*
       Read methods
       */
    /**
     * @template T
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.getLocalObject = /*
       Read methods
       */
    /**
     * @template T
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.getObject(this.localStorage, key);
    };
    /**
     * @template T
     * @param {?} keys
     * @return {?}
     */
    StorageService.prototype.getLocalObjects = /**
     * @template T
     * @param {?} keys
     * @return {?}
     */
    function (keys) {
        return this.getObjects(this.localStorage, keys);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.getLocalItem = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.getItem(this.localStorage, key);
    };
    /**
     * @template T
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.getSessionObject = /**
     * @template T
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.getObject(this.sessionStorage, key);
    };
    /**
     * @template T
     * @param {?} keys
     * @return {?}
     */
    StorageService.prototype.getSessionObjects = /**
     * @template T
     * @param {?} keys
     * @return {?}
     */
    function (keys) {
        return this.getObjects(this.sessionStorage, keys);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.getSessionItem = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.getItem(this.sessionStorage, key);
    };
    /**
     * @template T
     * @param {?} storage
     * @param {?} keys
     * @return {?}
     */
    StorageService.prototype.getObjects = /**
     * @template T
     * @param {?} storage
     * @param {?} keys
     * @return {?}
     */
    function (storage, keys) {
        var _this = this;
        return keys.map(function (key) { return _this.getObject(storage, key); });
    };
    /**
     * @private
     * @template T
     * @param {?} storage
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.getObject = /**
     * @private
     * @template T
     * @param {?} storage
     * @param {?} key
     * @return {?}
     */
    function (storage, key) {
        /** @type {?} */
        var jsonString = this.getItem(storage, key);
        if (jsonString === null) {
            return null;
        }
        try {
            return (/** @type {?} */ (JSON.parse(jsonString)));
        }
        catch (ex) {
            return null;
        }
    };
    /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.getItem = /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @return {?}
     */
    function (storage, key) {
        return storage.getItem(key) || null;
    };
    /**
     * @return {?}
     */
    StorageService.prototype.getWindowName = /**
     * @return {?}
     */
    function () {
        return this.window.name;
    };
    /*
     Remove methods
     */
    /*
       Remove methods
       */
    /**
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.removeLocalItem = /*
       Remove methods
       */
    /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.removeItem(this.localStorage, key);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.removeSessionItem = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.removeItem(this.sessionStorage, key);
    };
    /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.removeItem = /**
     * @private
     * @param {?} storage
     * @param {?} key
     * @return {?}
     */
    function (storage, key) {
        storage.removeItem(key);
    };
    /**
     * @return {?}
     */
    StorageService.prototype.clearLocalStorage = /**
     * @return {?}
     */
    function () {
        this.clearStorage(this.localStorage);
    };
    /**
     * @return {?}
     */
    StorageService.prototype.clearSessionStorage = /**
     * @return {?}
     */
    function () {
        this.clearStorage(this.sessionStorage);
    };
    /**
     * @private
     * @param {?} storage
     * @return {?}
     */
    StorageService.prototype.clearStorage = /**
     * @private
     * @param {?} storage
     * @return {?}
     */
    function (storage) {
        storage.clear();
    };
    /*
     Inspection methods
     */
    /*
       Inspection methods
       */
    /**
     * @return {?}
     */
    StorageService.prototype.getLocalItemKeys = /*
       Inspection methods
       */
    /**
     * @return {?}
     */
    function () {
        return this.getStorageItemKeys(this.localStorage);
    };
    /**
     * @return {?}
     */
    StorageService.prototype.getSessionItemKeys = /**
     * @return {?}
     */
    function () {
        return this.getStorageItemKeys(this.sessionStorage);
    };
    /**
     * @private
     * @param {?} storage
     * @return {?}
     */
    StorageService.prototype.getStorageItemKeys = /**
     * @private
     * @param {?} storage
     * @return {?}
     */
    function (storage) {
        /** @type {?} */
        var keys = [];
        for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
        }
        return keys;
    };
    StorageService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root',
                },] }
    ];
    /** @nocollapse */
    StorageService.ctorParameters = function () { return []; };
    /** @nocollapse */ StorageService.ngInjectableDef = defineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());
/* singleton pattern taken from https://github.com/angular/angular/issues/13854 */
/** @type {?} */
var StorageServiceProviderFactory = function (parentDispatcher) {
    return parentDispatcher || new StorageService();
};
/** @type {?} */
var StorageServiceProvider = {
    provide: StorageService,
    deps: [[new Optional(), new SkipSelf(), StorageService]],
    useFactory: StorageServiceProviderFactory,
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var WindowSaveStrategy = {
    /**
     * Default behaviour. Window data will not be saved.
     */
    NONE: 0,
    /**
     * Only save the window data when the storage (native window.name property) is empty/undefined, meaning nothing else is
     * probably utilizing it
     */
    SAVE_WHEN_EMPTY: 1,
    /**
     * Save the window data without checking whether the storage might be used by another script
     */
    SAVE_FORCE: 2,
    /**
     * Save window data, but backup probable existing data in the storage and restore the original data after reading the window data.
     * Restoring the original data might not happen "on time" for the script using it, which would require delaying it's execution.
     */
    SAVE_BACKUP: 3,
};
WindowSaveStrategy[WindowSaveStrategy.NONE] = 'NONE';
WindowSaveStrategy[WindowSaveStrategy.SAVE_WHEN_EMPTY] = 'SAVE_WHEN_EMPTY';
WindowSaveStrategy[WindowSaveStrategy.SAVE_FORCE] = 'SAVE_FORCE';
WindowSaveStrategy[WindowSaveStrategy.SAVE_BACKUP] = 'SAVE_BACKUP';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var NGXMW_CONFIG = new InjectionToken('ngxmw_config');
/** @type {?} */
var defaultMultiWindowConfig = {
    keyPrefix: 'ngxmw_',
    heartbeat: 1000,
    newWindowScan: 5000,
    messageTimeout: 10000,
    windowTimeout: 15000,
    windowSaveStrategy: WindowSaveStrategy.NONE,
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var MessageType = {
    MESSAGE: 0,
    MESSAGE_RECEIVED: 1,
    PING: 2,
};
MessageType[MessageType.MESSAGE] = 'MESSAGE';
MessageType[MessageType.MESSAGE_RECEIVED] = 'MESSAGE_RECEIVED';
MessageType[MessageType.PING] = 'PING';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var _window = function () {
    // return the global native browser window object
    return window;
};
var WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    Object.defineProperty(WindowRef.prototype, "nativeWindow", {
        get: /**
         * @return {?}
         */
        function () {
            return _window();
        },
        enumerable: true,
        configurable: true
    });
    WindowRef.decorators = [
        { type: Injectable }
    ];
    return WindowRef;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MultiWindowService = /** @class */ (function () {
    function MultiWindowService(customConfig, location, storageService, windowRef) {
        var _this = this;
        this.location = location;
        this.storageService = storageService;
        this.windowRef = windowRef;
        this.heartbeatId = null;
        this.windowScanId = null;
        this.knownWindows = [];
        /**
         * A hash that keeps track of subjects for all send messages
         */
        this.messageTracker = {};
        /**
         * A copy of the outbox that is regularly written to the local storage
         */
        this.outboxCache = {};
        /**
         * A subject to subscribe to in order to get notified about messages send to this window
         */
        this.messageSubject = new Subject();
        /**
         * A subject to subscribe to in order to get notified about all known windows
         */
        this.windowSubject = new BehaviorSubject(this.knownWindows);
        this.heartbeat = function () {
            /** @type {?} */
            var now = new Date().getTime();
            // Check whether there are new messages for the current window in the other window's outboxes
            // Store the ids of all messages we receive in this iteration
            /** @type {?} */
            var receivedMessages = [];
            _this.knownWindows.forEach(function (windowData) {
                // Load the window from the localstorage
                /** @type {?} */
                var appWindow = _this.storageService.getLocalObject(_this.generateWindowKey(windowData.id));
                if (appWindow === null) {
                    // No window found, it possibly got closed/removed since our last scanForWindow
                    return;
                }
                if (appWindow.id === _this.myWindow.id) {
                    // Ignore messages from myself (not done using Array.filter to reduce array iterations)
                    // but check for proper last heartbeat time
                    if (_this.myWindow.heartbeat !== -1 && _this.myWindow.heartbeat !== appWindow.heartbeat) {
                        // The heartbeat value in the localstorage is a different one than the one we wrote into localstorage
                        // during our last heartbeat. There are probably two app windows
                        // using the same window id => change the current windows id
                        _this.myWindow.id = MultiWindowService.generateId();
                        // tslint:disable-next-line:no-console
                        console.warn('Window ' + appWindow.id + '  detected that there is probably another instance with' +
                            ' this id, changed id to ' + _this.myWindow.id);
                        _this.storageService.setWindowName(_this.generateWindowKey(_this.myWindow.id));
                    }
                    return;
                }
                if (now - appWindow.heartbeat > _this.config.windowTimeout) {
                    // The window seems to be dead, remove the entry from the localstorage
                    _this.storageService.removeLocalItem(_this.generateWindowKey(appWindow.id));
                }
                // Update the windows name and heartbeat value in the list of known windows (that's what we iterate over)
                windowData.name = appWindow.name;
                windowData.heartbeat = appWindow.heartbeat;
                if (appWindow.messages && appWindow.messages.length > 0) {
                    // This other window has messages, so iterate over the messages the other window has
                    appWindow.messages.forEach(function (message) {
                        if (message.recipientId !== _this.myWindow.id) {
                            // The message is not targeted to the current window
                            return;
                        }
                        if (message.type === MessageType.MESSAGE_RECEIVED) {
                            // It's a message to inform the current window that a previously sent message from the
                            // current window has been processed by the recipient window
                            // Trigger the observable to complete and then remove it
                            if (_this.messageTracker[message.messageId]) {
                                _this.messageTracker[message.messageId].complete();
                            }
                            delete _this.messageTracker[message.messageId];
                            // Remove the message from the outbox, as the transfer is complete
                            delete _this.outboxCache[message.messageId];
                        }
                        else {
                            receivedMessages.push(message.messageId);
                            // Check whether we already processed that message. If that's the case we've got a 'message_received'
                            // confirmation in our own outbox.
                            if (!(_this.outboxCache[message.messageId] &&
                                _this.outboxCache[message.messageId].type === MessageType.MESSAGE_RECEIVED)) {
                                // We did not process that message
                                // Create a new message for the message sender in the current window's
                                // outbox that the message has been processed (reuse the message id for that)
                                _this.pushToOutbox({
                                    recipientId: message.senderId,
                                    type: MessageType.MESSAGE_RECEIVED,
                                    event: undefined,
                                }, message.messageId);
                                // Process it locally, unless it's just a PING message
                                if (message.type !== MessageType.PING) {
                                    if (message.payload === true) {
                                        // The message has a separate payload
                                        /** @type {?} */
                                        var payloadKey = _this.generatePayloadKey(message);
                                        message.payload = _this.storageService.getLocalObject(payloadKey);
                                        _this.storageService.removeLocalItem(payloadKey);
                                    }
                                    _this.messageSubject.next(message);
                                }
                            }
                        }
                    });
                }
            });
            // Iterate over the outbox to clean it up, process timeouts and payloads
            Object.keys(_this.outboxCache).forEach(function (messageId) {
                /** @type {?} */
                var message = _this.outboxCache[messageId];
                if (message.type === MessageType.MESSAGE_RECEIVED && !receivedMessages.some(function (msgId) { return msgId === messageId; })) {
                    // It's a message confirmation and we did not receive the 'original' method for that confirmation
                    // => the sender has received our confirmation and removed the message from it's outbox, thus we can
                    //     safely remove the message confirmation as well
                    delete _this.outboxCache[messageId];
                }
                else if (message.type !== MessageType.MESSAGE_RECEIVED && now - message.sendTime > _this.config.messageTimeout) {
                    // Delivering the message has failed, as the target window did not pick it up in time
                    // The type of message doesn't matter for that
                    delete _this.outboxCache[messageId];
                    if (_this.messageTracker[messageId]) {
                        _this.messageTracker[messageId].error('Timeout');
                    }
                    delete _this.messageTracker[messageId];
                }
                else if (message.type === MessageType.MESSAGE && message.send === false) {
                    if (message.payload !== undefined && message.payload !== true) {
                        // Message has a payload that has not been moved yet, so move that in a separate localstorage key
                        _this.storageService.setLocalObject(_this.generatePayloadKey(message), message.payload);
                        message.payload = true;
                    }
                    _this.messageTracker[message.messageId].next(message.messageId);
                    // Set property to undefined, as we do not need to encode "send:true" in the localstorage json multiple times
                    message.send = undefined;
                }
            });
            _this.storageService.setLocalObject(_this.generateWindowKey(_this.myWindow.id), {
                heartbeat: now,
                id: _this.myWindow.id,
                name: _this.myWindow.name,
                messages: Object.keys(_this.outboxCache).map(function (key) { return _this.outboxCache[key]; }),
            });
            if (_this.myWindow.heartbeat === -1) {
                // This was the first heartbeat run for the local window, so rescan for known windows to get
                // the current (new) window in the list
                _this.scanForWindows();
            }
            // Store the new heartbeat value in the local windowData copy
            _this.myWindow.heartbeat = now;
        };
        this.scanForWindows = function () {
            _this.knownWindows = _this.storageService.getLocalObjects(_this.storageService.getLocalItemKeys().filter(function (key) { return _this.isWindowKey(key); }))
                .map(function (_a) {
                var id = _a.id, name = _a.name, heartbeat = _a.heartbeat;
                return {
                    id: id,
                    name: name,
                    heartbeat: heartbeat,
                    stalled: new Date().getTime() - heartbeat > _this.config.heartbeat * 2,
                    self: _this.myWindow.id === id,
                };
            });
            _this.windowSubject.next(_this.knownWindows);
        };
        this.config = __assign({}, defaultMultiWindowConfig, customConfig);
        /** @type {?} */
        var windowId;
        if (this.location) {
            // Try to extract the new window name from the location path
            windowId = this.tryMatchWindowKey(this.location.path(true));
        }
        // Only check the name save strategy if no id has been extracted from the path already
        if (!windowId && this.config.windowSaveStrategy !== WindowSaveStrategy.NONE) {
            // There might be window data stored in the window.name property, try restoring it
            /** @type {?} */
            var storedWindowData = this.windowRef.nativeWindow.name;
            if (this.config.windowSaveStrategy === WindowSaveStrategy.SAVE_BACKUP) {
                // There should be a JSON string in the window.name, try parsing it and set the values
                try {
                    /** @type {?} */
                    var storedJsonData = JSON.parse(storedWindowData);
                    windowId = storedJsonData.ngxmw_id;
                    this.windowRef.nativeWindow.name = storedJsonData.backup;
                }
                catch (ex) { // Swallow JSON parsing exceptions, as we can't handle them anyway
                }
            }
            else {
                windowId = this.tryMatchWindowKey(storedWindowData);
                if (this.config.windowSaveStrategy === WindowSaveStrategy.SAVE_WHEN_EMPTY) {
                    this.windowRef.nativeWindow.name = '';
                }
            }
        }
        this.init(windowId);
        this.start();
    }
    /**
     * @private
     * @return {?}
     */
    MultiWindowService.generateId = /**
     * @private
     * @return {?}
     */
    function () {
        return new Date().getTime().toString(36).substr(-4) + Math.random().toString(36).substr(2, 9);
    };
    /**
     * @private
     * @param {?} source
     * @return {?}
     */
    MultiWindowService.prototype.tryMatchWindowKey = /**
     * @private
     * @param {?} source
     * @return {?}
     */
    function (source) {
        /** @type {?} */
        var nameRegex = new RegExp(
        // Escape any potential regex-specific chars in the keyPrefix which may be changed by the dev
        this.config.keyPrefix.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + 'w_([a-z0-9]+)');
        /** @type {?} */
        var match = source.match(nameRegex);
        if (match !== null) {
            return match[1];
        }
        return null;
    };
    /**
     * @private
     * @param {?} __0
     * @return {?}
     */
    MultiWindowService.prototype.generatePayloadKey = /**
     * @private
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var messageId = _a.messageId;
        return this.config.keyPrefix + 'payload_' + messageId;
    };
    /**
     * @private
     * @param {?} windowId
     * @return {?}
     */
    MultiWindowService.prototype.generateWindowKey = /**
     * @private
     * @param {?} windowId
     * @return {?}
     */
    function (windowId) {
        return this.config.keyPrefix + 'w_' + windowId;
    };
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    MultiWindowService.prototype.isWindowKey = /**
     * @private
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return key.indexOf(this.config.keyPrefix + 'w_') === 0;
    };
    Object.defineProperty(MultiWindowService.prototype, "name", {
        get: /**
         * @return {?}
         */
        function () {
            return this.myWindow.name;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.myWindow.name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiWindowService.prototype, "id", {
        get: /**
         * @return {?}
         */
        function () {
            return this.myWindow.id;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * An observable to subscribe to. It emits all messages the current window receives.
     * After a message has been emitted by this observable it is marked as read, so the sending window
     * gets informed about successful delivery.
     */
    /**
     * An observable to subscribe to. It emits all messages the current window receives.
     * After a message has been emitted by this observable it is marked as read, so the sending window
     * gets informed about successful delivery.
     * @return {?}
     */
    MultiWindowService.prototype.onMessage = /**
     * An observable to subscribe to. It emits all messages the current window receives.
     * After a message has been emitted by this observable it is marked as read, so the sending window
     * gets informed about successful delivery.
     * @return {?}
     */
    function () {
        return this.messageSubject.asObservable();
    };
    /**
     * An observable to subscribe to. It emits the array of known windows
     * whenever it is read again from the localstorage.
     *
     * This Observable emits the last list of known windows on subscription
     * (refer to rxjs BehaviorSubject).
     *
     * Use {@link getKnownWindows} to get the current list of
     * known windows or if you only need a snapshot of that list.
     *
     * @see {@link MultiWindowConfig#newWindowScan}
     * @returns
     */
    /**
     * An observable to subscribe to. It emits the array of known windows
     * whenever it is read again from the localstorage.
     *
     * This Observable emits the last list of known windows on subscription
     * (refer to rxjs BehaviorSubject).
     *
     * Use {\@link getKnownWindows} to get the current list of
     * known windows or if you only need a snapshot of that list.
     *
     * @see {\@link MultiWindowConfig#newWindowScan}
     * @return {?}
     */
    MultiWindowService.prototype.onWindows = /**
     * An observable to subscribe to. It emits the array of known windows
     * whenever it is read again from the localstorage.
     *
     * This Observable emits the last list of known windows on subscription
     * (refer to rxjs BehaviorSubject).
     *
     * Use {\@link getKnownWindows} to get the current list of
     * known windows or if you only need a snapshot of that list.
     *
     * @see {\@link MultiWindowConfig#newWindowScan}
     * @return {?}
     */
    function () {
        return this.windowSubject.asObservable();
    };
    /**
     * Get the latest list of known windows.
     *
     * Use {@link onWindows} to get an observable which emits
     * whenever is updated.
     */
    /**
     * Get the latest list of known windows.
     *
     * Use {\@link onWindows} to get an observable which emits
     * whenever is updated.
     * @return {?}
     */
    MultiWindowService.prototype.getKnownWindows = /**
     * Get the latest list of known windows.
     *
     * Use {\@link onWindows} to get an observable which emits
     * whenever is updated.
     * @return {?}
     */
    function () {
        return this.knownWindows;
    };
    /**
     * Start so that the current instance of the angular app/service/tab participates in the cross window communication.
     * It starts the interval-based checking for messages and updating the heartbeat.
     *
     * Note: There should be no need to call this method in production apps. It will automatically be called internally
     * during service construction (see {@link MultiWindowService} constructor)
     */
    /**
     * Start so that the current instance of the angular app/service/tab participates in the cross window communication.
     * It starts the interval-based checking for messages and updating the heartbeat.
     *
     * Note: There should be no need to call this method in production apps. It will automatically be called internally
     * during service construction (see {\@link MultiWindowService} constructor)
     * @return {?}
     */
    MultiWindowService.prototype.start = /**
     * Start so that the current instance of the angular app/service/tab participates in the cross window communication.
     * It starts the interval-based checking for messages and updating the heartbeat.
     *
     * Note: There should be no need to call this method in production apps. It will automatically be called internally
     * during service construction (see {\@link MultiWindowService} constructor)
     * @return {?}
     */
    function () {
        if (!this.heartbeatId) {
            this.heartbeatId = setInterval(this.heartbeat, this.config.heartbeat);
        }
        if (!this.windowScanId) {
            this.windowScanId = setInterval(this.scanForWindows, this.config.newWindowScan);
        }
    };
    /**
     * Stop the current instance of the angular app/service/tab from participating in the cross window communication.
     * It stops the interval-based checking for messages and updating the heartbeat.
     *
     * Note: There should be no need to call this method in production apps.
     */
    /**
     * Stop the current instance of the angular app/service/tab from participating in the cross window communication.
     * It stops the interval-based checking for messages and updating the heartbeat.
     *
     * Note: There should be no need to call this method in production apps.
     * @return {?}
     */
    MultiWindowService.prototype.stop = /**
     * Stop the current instance of the angular app/service/tab from participating in the cross window communication.
     * It stops the interval-based checking for messages and updating the heartbeat.
     *
     * Note: There should be no need to call this method in production apps.
     * @return {?}
     */
    function () {
        if (this.heartbeatId) {
            clearInterval(this.heartbeatId);
            this.heartbeatId = null;
        }
        if (this.windowScanId) {
            clearInterval(this.windowScanId);
            this.windowScanId = null;
        }
    };
    /**
     * Remove the current window representation from the localstorage.
     *
     * Note: Unless you {@link stop}ped the service the window representation will be
     * recreated after {@link MultiWindowConfig#heartbeat} milliseconds
     */
    /**
     * Remove the current window representation from the localstorage.
     *
     * Note: Unless you {\@link stop}ped the service the window representation will be
     * recreated after {\@link MultiWindowConfig#heartbeat} milliseconds
     * @return {?}
     */
    MultiWindowService.prototype.clear = /**
     * Remove the current window representation from the localstorage.
     *
     * Note: Unless you {\@link stop}ped the service the window representation will be
     * recreated after {\@link MultiWindowConfig#heartbeat} milliseconds
     * @return {?}
     */
    function () {
        this.storageService.removeLocalItem(this.generateWindowKey(this.myWindow.id));
    };
    /**
     * Send a message to another window.
     *
     * @param recipientId The ID of the recipient window.
     * @param event Custom identifier to distinguish certain events
     * @param data Custom data to contain the data for the event
     * @param payload Further data to be passed to the recipient window via a separate entry in the localstorage
     * @returns An observable that emits the messageId once the message has been put into
     * the current windows outbox. It completes on successful delivery and fails if the delivery times out.
     */
    /**
     * Send a message to another window.
     *
     * @param {?} recipientId The ID of the recipient window.
     * @param {?} event Custom identifier to distinguish certain events
     * @param {?} data Custom data to contain the data for the event
     * @param {?=} payload Further data to be passed to the recipient window via a separate entry in the localstorage
     * @return {?} An observable that emits the messageId once the message has been put into
     * the current windows outbox. It completes on successful delivery and fails if the delivery times out.
     */
    MultiWindowService.prototype.sendMessage = /**
     * Send a message to another window.
     *
     * @param {?} recipientId The ID of the recipient window.
     * @param {?} event Custom identifier to distinguish certain events
     * @param {?} data Custom data to contain the data for the event
     * @param {?=} payload Further data to be passed to the recipient window via a separate entry in the localstorage
     * @return {?} An observable that emits the messageId once the message has been put into
     * the current windows outbox. It completes on successful delivery and fails if the delivery times out.
     */
    function (recipientId, event, data, payload) {
        /** @type {?} */
        var messageId = this.pushToOutbox({
            recipientId: recipientId,
            type: MessageType.MESSAGE,
            event: event,
            data: data,
            payload: payload,
        });
        this.messageTracker[messageId] = new Subject();
        return this.messageTracker[messageId].asObservable();
    };
    /**
     * Create a new window and get informed once it has been created.
     *
     * Note: The actual window "creation" of redirection needs to be performed by
     * the library user. This method only returns helpful information on how to
     * do that
     *
     * The returned object contains three properties:
     *
     * windowId: An id generated to be assigned to the newly created window
     *
     * urlString: This string must be included in the url the new window loads.
     * It does not matter whether it is in the path, query or hash part
     *
     * created: An observable that will complete after new window was opened and was able
     * to receive a message. If the window does not start consuming messages within
     * {@link MultiWindowConfig#messageTimeout}, this observable will fail, although
     * the window might become present after that. The Observable will never emit any elements.
     */
    /**
     * Create a new window and get informed once it has been created.
     *
     * Note: The actual window "creation" of redirection needs to be performed by
     * the library user. This method only returns helpful information on how to
     * do that
     *
     * The returned object contains three properties:
     *
     * windowId: An id generated to be assigned to the newly created window
     *
     * urlString: This string must be included in the url the new window loads.
     * It does not matter whether it is in the path, query or hash part
     *
     * created: An observable that will complete after new window was opened and was able
     * to receive a message. If the window does not start consuming messages within
     * {\@link MultiWindowConfig#messageTimeout}, this observable will fail, although
     * the window might become present after that. The Observable will never emit any elements.
     * @return {?}
     */
    MultiWindowService.prototype.newWindow = /**
     * Create a new window and get informed once it has been created.
     *
     * Note: The actual window "creation" of redirection needs to be performed by
     * the library user. This method only returns helpful information on how to
     * do that
     *
     * The returned object contains three properties:
     *
     * windowId: An id generated to be assigned to the newly created window
     *
     * urlString: This string must be included in the url the new window loads.
     * It does not matter whether it is in the path, query or hash part
     *
     * created: An observable that will complete after new window was opened and was able
     * to receive a message. If the window does not start consuming messages within
     * {\@link MultiWindowConfig#messageTimeout}, this observable will fail, although
     * the window might become present after that. The Observable will never emit any elements.
     * @return {?}
     */
    function () {
        if (this.location === null) {
            // Reading information from the URL is only possible with the Location provider. If
            // this window does not have one, another one will have none as well and thus would
            // not be able to read its new windowId from the url path
            throw new Error('No Location Provider present');
        }
        /** @type {?} */
        var newWindowId = MultiWindowService.generateId();
        /** @type {?} */
        var messageId = this.pushToOutbox({
            recipientId: newWindowId,
            type: MessageType.PING,
            event: undefined,
            data: undefined,
            payload: undefined,
        });
        this.messageTracker[messageId] = new Subject();
        return {
            windowId: newWindowId,
            urlString: this.generateWindowKey(newWindowId),
            created: this.messageTracker[messageId].pipe(ignoreElements()),
        };
    };
    /**
     * @return {?}
     */
    MultiWindowService.prototype.saveWindow = /**
     * @return {?}
     */
    function () {
        if (this.config.windowSaveStrategy !== WindowSaveStrategy.NONE) {
            /** @type {?} */
            var windowId = this.generateWindowKey(this.id);
            if ((this.config.windowSaveStrategy === WindowSaveStrategy.SAVE_WHEN_EMPTY && !this.windowRef.nativeWindow.name)
                || this.config.windowSaveStrategy === WindowSaveStrategy.SAVE_FORCE) {
                this.windowRef.nativeWindow.name = windowId;
            }
            else if (this.config.windowSaveStrategy === WindowSaveStrategy.SAVE_BACKUP) {
                this.windowRef.nativeWindow.name = JSON.stringify({ ngxmw_id: windowId, backup: this.windowRef.nativeWindow.name });
            }
        }
    };
    /**
     * @private
     * @param {?=} windowId
     * @return {?}
     */
    MultiWindowService.prototype.init = /**
     * @private
     * @param {?=} windowId
     * @return {?}
     */
    function (windowId) {
        /** @type {?} */
        var windowKey = windowId
            ? this.generateWindowKey(windowId)
            : this.storageService.getWindowName();
        /** @type {?} */
        var windowData = null;
        if (windowKey && this.isWindowKey(windowKey)) {
            windowData = this.storageService.getLocalObject(windowKey);
        }
        if (windowData !== null) {
            // Restore window information from storage
            this.myWindow = {
                id: windowData.id,
                name: windowData.name,
                heartbeat: windowData.heartbeat,
            };
        }
        else {
            /** @type {?} */
            var myWindowId = windowId || MultiWindowService.generateId();
            this.myWindow = {
                id: myWindowId,
                name: 'AppWindow ' + myWindowId,
                heartbeat: -1,
            };
        }
        this.storageService.setWindowName(windowKey);
        // Scan for already existing windows
        this.scanForWindows();
        // Trigger heartbeat for the first time
        this.heartbeat();
    };
    /**
     * @private
     * @param {?} __0
     * @param {?=} messageId
     * @return {?}
     */
    MultiWindowService.prototype.pushToOutbox = /**
     * @private
     * @param {?} __0
     * @param {?=} messageId
     * @return {?}
     */
    function (_a, messageId) {
        var recipientId = _a.recipientId, type = _a.type, event = _a.event, data = _a.data, payload = _a.payload;
        if (messageId === void 0) { messageId = MultiWindowService.generateId(); }
        if (recipientId === this.id) {
            throw new Error('Cannot send messages to self');
        }
        this.outboxCache[messageId] = {
            messageId: messageId,
            recipientId: recipientId,
            senderId: this.myWindow.id,
            sendTime: new Date().getTime(),
            type: type,
            event: event,
            data: data,
            payload: payload,
            send: false,
        };
        return messageId;
    };
    MultiWindowService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root',
                },] }
    ];
    /** @nocollapse */
    MultiWindowService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [NGXMW_CONFIG,] }] },
        { type: Location, decorators: [{ type: Optional }] },
        { type: StorageService },
        { type: WindowRef }
    ]; };
    /** @nocollapse */ MultiWindowService.ngInjectableDef = defineInjectable({ factory: function MultiWindowService_Factory() { return new MultiWindowService(inject(NGXMW_CONFIG), inject(Location, 8), inject(StorageService), inject(WindowRef)); }, token: MultiWindowService, providedIn: "root" });
    return MultiWindowService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$1 = {};
var MultiWindowModule = /** @class */ (function () {
    function MultiWindowModule() {
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    MultiWindowModule.forRoot = /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: MultiWindowModule,
            providers: [MultiWindowService, { provide: NGXMW_CONFIG, useValue: config }],
        };
    };
    MultiWindowModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    providers: [
                        StorageService,
                        MultiWindowService,
                        WindowRef,
                        { provide: NGXMW_CONFIG, useValue: ɵ0$1 },
                    ],
                },] }
    ];
    return MultiWindowModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MultiWindowModule, NGXMW_CONFIG, defaultMultiWindowConfig, MultiWindowService, StorageService, StorageServiceProviderFactory, StorageServiceProvider, WindowRef, MessageType, WindowSaveStrategy };

//# sourceMappingURL=ngx-multi-window.js.map